import { UserLayout } from '@/layout';
import { ajax } from '@/store/midPromise';
import { public_info } from '@/store/model/reducers/golbal';
import { api_index } from '@/store/model/reducers/index';
import { LockOutlined, MessageOutlined, UserOutlined, WarningOutlined } from '@ant-design/icons';
import { Button, Form, Input, Tabs, message } from 'antd';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import { Dispatch } from 'redux';
import './index.less';
const { TabPane } = Tabs;

const windowObj = global.windows || window;

const tailLayout = {
    wrapperCol: { offset: 0, span: 24 },
};

interface Interfaceprops extends RouteComponentProps {
    userLogin: (data: any) => void;
    get_public: () => void;
}

const Index: React.FC<Interfaceprops> = props => {
    const [type, setType] = useState('password');
    const [msgdisabled, setmsgdisabled] = useState(false);
    const [msgText, setmsgText] = useState('获取验证码');
    const [loginInfo, setLoginInfo] = useState(false);
    const [loading, setLoading] = useState(false);
    const [verifyStatus, setVerifyStatus] = useState(0); // 0无，1图形验证码，2短信验证码，3锁定
    const [captchaBase64, setCaptchaBase64] = useState('');
    const [countdown, setCountdown] = useState(0);
    const [captchaUuid, setCaptchaUuid] = useState(''); // 图形验证码对应的 uuid

    useEffect(() => {
        let timer: any = null;
        if (countdown > 0) {
            timer = setTimeout(() => {
                setCountdown(countdown - 1);
            }, 1000);
            setmsgdisabled(true);
            setmsgText(`${countdown}s后重新获取`);
        } else {
            setmsgdisabled(false);
            setmsgText(`重新获取`);
        }
        return () => {
            if (timer) clearTimeout(timer);
        };
    }, [countdown]);

    const callback = (key: string) => {
        setType(key);
    };

    const refreshCaptcha = () => {
        ajax.get('/api/auth/captcha.jpg').then((res: any) => {
            if (res && res.code === 200 && res.data) {
                // 后端可能返回纯 base64，也可能返回 { uuid, imgData }
                let imgStr: string | undefined;

                if (typeof res.data === 'string') {
                    imgStr = res.data;
                } else if (res.data.imgData) {
                    imgStr = res.data.imgData;
                }

                if (imgStr) {
                    // 如果缺少头部信息就补上 data:image/jpeg;base64,
                    if (!imgStr.startsWith('data:image')) {
                        imgStr = `data:image/jpeg;base64,${imgStr}`;
                    }
                    setCaptchaBase64(imgStr);
                } else {
                    setCaptchaBase64('');
                }
                if (res.data?.uuid) {
                    setCaptchaUuid(res.data.uuid);
                } else {
                    setCaptchaUuid('');
                }
            } else {
                setCaptchaBase64('');
            }
        });
    };

    const getMsg = () => {
        let phone = formLogin.getFieldValue('phone');
        phone = phone && phone.replace(/\s+/g, '');
        if (phone.length !== 11) return;
        setCountdown(60);
        ajax.post('/api/auth/getCode', { phone: phone }).then((res: any) => {
            if (!(res && res.code === 200)) setCountdown(0);
        });
    };

    const onFinish = (values: any) => {
        values.phone = values.phone.replace(/\s+/g, '');
        if (captchaUuid) {
            values.verifyUuid = captchaUuid; // 将 uuid 一并提交给后端
        }
        if (values.testCode) {
            values.smsCode = values.testCode; // 将验证码转存为 smsCode
            delete values.testCode; // 移除多余字段
        }
        console.log(' onFinish ', values);
        const olddata = { ...values };
        const data = windowObj.GLOBAL_LIBS.toFormData(olddata);
        setLoading(true);

        // 将短信验证码复制到后端所需的字段

        props.userLogin({
            data,
            success: (result: any) => {
                setLoading(false);
                console.log('userLogin 成功  ', result);
                message.success('登录成功');
                // windowObj.localStorage.setItem('token', result.token);
                windowObj.localStorage.setItem('apiName', result.roleName);
                console.log('document.cookie:', document.cookie);
                setTimeout(() => {
                    console.log('10毫秒 document.cookie2:', document.cookie);
                    props.get_public();
                }, 10);
                switch (result.roleName) {
                    case 'customer':
                        props.history.push('/lingGong_C/bill/upload');
                        break;
                    case 'company':
                        props.history.push('/lingGong_B/bill/manage');
                        break;
                    case 'business':
                        props.history.push('/pass/business/supplier');
                        break;
                    case 'signassistant':
                        props.history.push('/sign_helper/loading');
                        break;
                    case 'taxBureau':
                        props.history.push('/flexibleLabor/tax/check');
                        break;
                    case 'splitsalary':
                        props.history.push('/wageSplit');
                        window.location.reload();
                        break;
                }
            },
            overFn: (res: any) => {
                console.log('userLogin  overFn:', res);
                setLoading(false);
                if (res) {
                    const errorCount = res.data?.errorCount; // 从 data 里拿errorCount
                    if (errorCount !== undefined) {
                        if (errorCount >= 5) {
                            setVerifyStatus(3); // 锁定
                        } else if (errorCount >= 3) {
                            setVerifyStatus(2); // 手机验证码
                        } else if (errorCount >= 1) {
                            setVerifyStatus(1); // 图形验证码
                            refreshCaptcha(); // 获取图形验证码
                        }
                    }
                }
            },
        });
    };

    const [formLogin] = Form.useForm();
    const getLoginStatus = () => {
        let phone = formLogin.getFieldValue('phone');
        if (phone) phone = phone.replace(/\s+/g, '');

        ajax.post('/api/auth/first', { phone }).then((res: any) => {
            if (res && res.code === 200) {
                setLoginInfo(res.data);

                const errorCount = res.data?.errorCount; // 新增字段
                if (errorCount !== undefined) {
                    if (errorCount >= 5) {
                        setVerifyStatus(3); // 账户锁定
                    } else if (errorCount >= 3) {
                        setVerifyStatus(2); // 需要短信验证码
                    } else if (errorCount >= 1) {
                        setVerifyStatus(1); // 需要图形验证码
                        refreshCaptcha(); // 立即获取图形验证码
                    } else {
                        setVerifyStatus(0); // 不需要验证码
                    }
                } else {
                    setVerifyStatus(0); // 默认不需要验证码
                }
            }
        });
    };
    const formChange = (data: any) => {
        data.phone = data.phone && data.phone.replace(/\s+/g, '');
        if (data.phone && data.phone.length === 11) {
            getLoginStatus();
        }
    };

    return (
        <UserLayout>
            <div className={'layoutLogin'}>
                <Tabs defaultActiveKey={type} onChange={callback} className={'userTabs'}>
                    <TabPane tab="账户密码登录" key="password">
                        <Form
                            name="basic"
                            form={formLogin}
                            initialValues={{ remember: true }}
                            onValuesChange={formChange}
                            onFinish={onFinish}
                        >
                            <Form.Item
                                wrapperCol={{ span: 24 }}
                                name="phone"
                                rules={[{ required: true, message: '请输入账户!' }]}
                            >
                                <Input
                                    prefix={<UserOutlined className="site-form-item-icon" />}
                                    placeholder="账户"
                                />
                            </Form.Item>
                            <Form.Item
                                wrapperCol={{ span: 24 }}
                                name="password"
                                rules={[{ required: true, message: '请输入密码!' }]}
                            >
                                <Input.Password
                                    type="password"
                                    placeholder="密码"
                                    prefix={<LockOutlined className="site-form-item-icon" />}
                                />
                            </Form.Item>

                            {verifyStatus === 1 && (
                                <Form.Item
                                    wrapperCol={{ span: 24 }}
                                    name="verifyCode"
                                    rules={[{ required: true, message: '请输入图形验证码!' }]}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <Input
                                            type="text"
                                            placeholder="请输入图形验证码"
                                            style={{ flex: 1 }}
                                        />
                                        {captchaBase64 && (
                                            <img
                                                src={captchaBase64}
                                                alt="captcha"
                                                onClick={refreshCaptcha}
                                                style={{
                                                    marginLeft: 10,
                                                    cursor: 'pointer',
                                                    height: 32,
                                                }}
                                            />
                                        )}
                                    </div>
                                </Form.Item>
                            )}

                            {verifyStatus === 2 && (
                                <Form.Item
                                    wrapperCol={{ span: 24 }}
                                    name="testCode"
                                    rules={[{ required: true, message: '请输入验证码!' }]}
                                >
                                    <p>
                                        <Input
                                            type="text"
                                            prefix={
                                                <MessageOutlined className="site-form-item-icon" />
                                            }
                                            style={{ width: '65%' }}
                                            className="code"
                                            placeholder="请输入验证码"
                                        />
                                        <Button
                                            type="primary"
                                            style={{ width: '35%' }}
                                            disabled={msgdisabled}
                                            onClick={getMsg}
                                        >
                                            {msgText}
                                        </Button>
                                    </p>
                                </Form.Item>
                            )}

                            {verifyStatus === 3 && (
                                <div
                                    style={{
                                        color: 'red',
                                        marginBottom: 12,
                                        fontSize: 14,
                                        textAlign: 'center',
                                    }}
                                >
                                    账户已被锁定，请稍后再试
                                </div>
                            )}

                            <div style={{ marginBottom: '20px' }}>
                                <WarningOutlined />
                                <span style={{ marginLeft: '10px', fontSize: '12px' }}>
                                    你登录的系统在后台有日志记录，若违反公司信息安全规定，违规获取敏感数据将会受到法律的制裁
                                </span>
                            </div>

                            <Form.Item {...tailLayout} className="btnForm">
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    className="loginBtn"
                                    loading={loading}
                                    disabled={verifyStatus === 3}
                                >
                                    登录
                                </Button>
                            </Form.Item>
                        </Form>
                        <div className="c_text_right">
                            <Button type="link" size={'small'} className="forgetBtn">
                                {' '}
                                <Link to={'/user/setPassword'}>忘记密码?</Link>
                            </Button>
                        </div>
                    </TabPane>
                </Tabs>
            </div>
        </UserLayout>
    );
};

const mapStateProps = (state: any) => {
    return {};
};
const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        userLogin: (data: any) => {
            console.log('userLogin __001');
            dispatch(api_index(data)('login'));
        },
        get_public: () => {
            console.log('get_public __001');
            dispatch(public_info());
        },
    };
};

export default connect(mapStateProps, mapDispatchToProps)(Index);
